import { FC, SyntheticEvent, useState } from 'react';
import MainLayout from 'src/pages/private';
import {
  PageContainer,
  StyledTabs,
  StyledTab,
  TabPanelContainer,
} from './ChequeStatus.styles';
import OrdersChequeTab from './OrdersChequeTab';
import GRNChequeTab from './GRNChequeTab';
import VouchersChequeTab from './VouchersChequeTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <TabPanelContainer
      role="tabpanel"
      hidden={value !== index}
      id={`cheque-status-tabpanel-${index}`}
      aria-labelledby={`cheque-status-tab-${index}`}
    >
      {value === index && children}
    </TabPanelContainer>
  );
};

const ChequeStatus: FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <MainLayout title="Cheque Status">
      <PageContainer>
        <StyledTabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="cheque status tabs"
        >
          <StyledTab
            label="Orders"
            id="cheque-status-tab-0"
            aria-controls="cheque-status-tabpanel-0"
            selected={tabValue === 0}
          />
          <StyledTab
            label="GRN"
            id="cheque-status-tab-1"
            aria-controls="cheque-status-tabpanel-1"
            selected={tabValue === 1}
          />
          <StyledTab
            label="Vouchers"
            id="cheque-status-tab-2"
            aria-controls="cheque-status-tabpanel-2"
            selected={tabValue === 2}
          />
        </StyledTabs>

        <TabPanel value={tabValue} index={0}>
          <OrdersChequeTab />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <GRNChequeTab />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <VouchersChequeTab />
        </TabPanel>
      </PageContainer>
    </MainLayout>
  );
};

export default ChequeStatus;
